/**
 * Article content overlay
 */
window.showArticleContentLayer = (selector) => {
    $(selector).articleContentLayer('show', function(){
        $('body').addClass('show-article-content-layer show-article-footer-actions');

        // Init lazyembed for external videos
        window.initOverlayLazyEmbed('.articleDetailVideoHolder .embed-responsive > iframe[data-lazyembed-overlay="video"]')

        if(window.checkViewport('min-width: 992px')) {
            $('header').addClass('is-fixed');
        }
    });
}
